import React, {useEffect, useRef, useState} from 'react';

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    iconButtonClasses,
    Menu,
    MenuItem,
    Paper,
    Typography
} from "@mui/material";
import {makeStyles} from "@mui/styles";

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Cookies from 'universal-cookie';

import {useAuth} from "../utils/useAuth";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '95px',
        marginLeft: '25px',
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        display: 'grid',
        margin: '15px',
        width: '95%',
        height: '-webkit-available'
    }
}));

export default function Wishlist(props) {
    const classes = useStyles();
    const inputEl = useRef(iconButtonClasses);

    const [anchorEl, setAnchorEl] = useState(null);
    const [openFormDialog, setOpenFormDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [value, setValue] = useState('');
    const [wishlistName, setWishlistName] = useState('');
    const [wishlistClient, setWishlistClient] = useState('');
    const [loading, setLoading] = useState(true);
    const [wishlists, setWishlists] = useState([]);

    const [state, setState] = useState({
        openSuccess: false,
        openError: false,
        vertical: 'top',
        horizontal: 'right',
        successMessage: '',
        errorMessage: ''
    });
    const { vertical, horizontal, openSuccess, successMessage, openError, errorMessage } = state;

    const { getAccessToken } = useAuth();

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    useEffect(() => {
        fetchWishlists();
    }, [props.selectedEvent]);

    const handleClose1 = (e) => {
        setAnchorEl(null);
        e.stopPropagation();
    };

    const handleClose = () => {
        setState({ ...state, openSuccess: false, openError: false });
    };

    const handleChange = (event) => setValue(event.target.value);
    const handleChangeName = (event) => setWishlistName(event.target.value);
    const handleChangeClient = (event) => setWishlistClient(event.target.value);

    const handleOpenFormDialog = (bool) => {
        setOpenFormDialog(bool);
        if (!bool) {
            setWishlistName('');
            setWishlistClient('');
            setValue('');
        }
    };

    const handleOpenDeleteMenu = (event, bool, wishlist) => {
        event.stopPropagation();
        setOpenDeleteDialog(bool);
    };

    const handleClick1 = (index, event) => {
        event.stopPropagation();
        setAnchorEl({ [index]: event.currentTarget });
    };

    const back = async () => {
        props.setWishlist(false);
    };

    const next = async (wishlist) => {
        props.setWishlistDetail(true);
        props.getWishlistDetail(wishlist);
    };

    const fetchWishlists = async () => {
        if (!props.selectedEvent?.id) return;
        setLoading(true);

        try {
            const accessToken = await getAccessToken();
            if (!accessToken) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get('hashCode') || "";

            const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}wishlists?eventID=${props.selectedEvent.id}`, {
                method: 'GET',
                headers: { Authorization: accessToken + hashCode }
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const result = await res.json();
            setWishlists(result);
        } catch (err) {
            console.error("fetchWishlists error:", err);
        } finally {
            setLoading(false);
        }
    };

    const addWishlist = async () => {
        handleOpenFormDialog(false);
        setLoading(true);

        try {
            const accessToken = await getAccessToken();
            const cookies = new Cookies();

            const myHeaders = new Headers();
            myHeaders.append("Authorization", accessToken + cookies.get('hashCode'));
            myHeaders.append("Content-Type", "application/json");

            const today = new Date();
            const formattedDate = `${String(today.getDate()).padStart(2,'0')}/${String(today.getMonth()+1).padStart(2,'0')}/${today.getFullYear()}`;
            const raw = JSON.stringify({
                id: '',
                eventID: props.selectedEvent.id,
                name: wishlistName,
                lastEdit: formattedDate,
                client: wishlistClient,
                products: [],
                timestamp: Math.floor(Date.now() / 1000).toString()
            });

            const res = await fetch(process.env.REACT_APP_API_ENDPOINT + "wishlists", {
                method: 'POST',
                headers: myHeaders,
                body: raw
            });
            const result = await res.json();
            fetchWishlists();
            setState({ openSuccess: true, openError: false, successMessage: "Wishlist added successfully!" });
        } catch (err) {
            console.error(err);
            setState({ loading: false, openError: true, openSuccess: false, errorMessage: "Something went wrong." });
        } finally {
            setLoading(false);
        }
    };

    const deleteWishlist = async (event, bool, wishlist) => {
        event.stopPropagation();
        setAnchorEl(null);
        setLoading(true);

        try {
            const accessToken = await getAccessToken();
            const cookies = new Cookies();
            const myHeaders = new Headers();
            myHeaders.append("Authorization", accessToken + cookies.get('hashCode'));
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({ id: wishlist.id });

            const res = await fetch(process.env.REACT_APP_API_ENDPOINT + "wishlists", {
                method: 'DELETE',
                headers: myHeaders,
                body: raw
            });
            await res.json();
            handleOpenDeleteMenu(event, bool);
            fetchWishlists();
            setState({ openSuccess: true, openError: false, successMessage: "Wishlist deleted successfully!" });
        } catch (err) {
            console.error(err);
            handleOpenDeleteMenu(event, bool);
            setState({ loading: false, openError: true, openSuccess: false, errorMessage: "Something went wrong." });
        } finally {
            setLoading(false);
        }
    };

    const getWishListPacks = () => {
        if (!wishlists.length) return "Nessuna wishlist presente";

        return wishlists.map((w, index) =>
            <div className="mt-15" key={w.id}>
                <Button className='template_button_wishlist pl-15' onClick={() => next(w)}>
                    <div className="grid w-99">
                        <div className='flex wishlist_title '>
                            <div className='gucci_text_bold ml-8 capitalize left wishlist_name'> {w.name} | {w.products.length}</div>
                            <div className='hotspot_button wishlist_vert_icon'>
                                <Button
                                    ref={inputEl}
                                    aria-owns={anchorEl ? 'menu-appbar' : null}
                                    aria-haspopup="true"
                                    onClick={(e) => handleClick1(index, e)}
                                    color="primary"
                                    className='complete_button'
                                >
                                    <MoreVertIcon />
                                </Button>
                                <Menu
                                    anchorEl={anchorEl && anchorEl[index]}
                                    keepMounted
                                    open={Boolean(anchorEl && anchorEl[index])}
                                    onClose={handleClose1}
                                    id="menu-appbar"
                                    className='menu_personale'
                                >
                                    <MenuItem onClick={(event) => deleteWishlist(event, false, w)}>Delete Wishlist</MenuItem>
                                </Menu>
                            </div>
                        </div>
                        <div className="grid left wishlist_details">
                            <div className='gucci_text ml-8 capitalize '> Client: {w.client}</div>
                            <div className='gucci_text ml-8 capitalize'> Creation Date: {w.lastEdit}</div>
                        </div>
                    </div>
                </Button>
            </div>
        );
    };

    return (
        <div className={classes.root}>
            {loading ?
                <div style={{ textAlign: 'center' }}>
                    <Typography style={{ paddingBottom: '20px' }} variant="h6" >Loading...</Typography>
                    <CircularProgress />
                </div>
                :
                <div>
                    <Grid item xs={2} className="ml-20" >
                        <Button className='red template_button pl-15' startIcon={<ArrowBackIosNewIcon color='error' />} onClick={back}>
                            <div className='gucci_text_bold ml-8 '>Back</div>
                        </Button>
                    </Grid>

                    <div className="gucci_text_bold mt-8 ml-8">
                        <Grid container alignItems="center" justifyContent="center" >
                            <Grid item xs={12}>
                                <Paper className={classes.paper}>
                                    <div className="flex center_align">
                                        <div className="flex center_align">
                                            <LocalMallIcon className="wishlist_icon" />
                                            <Typography className="gucci_text_bold" variant="h5">Wishlists</Typography>
                                        </div>
                                        <div className='hotspot_button left_align'>
                                            <Button onClick={() => handleOpenFormDialog(true)} color="primary" className='complete_button' startIcon={<AddIcon />} />
                                        </div>
                                    </div>
                                    <div className="mt-15 flex wrap">{getWishListPacks()}</div>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>

                    {/* ------------------ ADD WISHLIST DIALOG ------------------ */}
                    <Dialog
                        open={openFormDialog}
                        onClose={() => handleOpenFormDialog(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth maxWidth="sm"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <Typography className="gucci_text_bold" variant="h5">New wishlist</Typography>
                        </DialogTitle>
                        <DialogContent>
                            <TextField id="wishlist_name" label="Name your wishlist" variant="standard" onChange={handleChangeName} />
                            <div id='client_new_wishlist_dialog'>
                                <TextField id="wishlist_client" label="Client name" variant="standard" onChange={handleChangeClient} />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleOpenFormDialog(false)} className="black template_button">Cancel</Button>
                            <Button onClick={addWishlist} className="red template_button" autoFocus>Create</Button>
                        </DialogActions>
                    </Dialog>

                    {/* ------------------ SNACKBARS ------------------ */}
                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity="success" dx={{ width: '300px' }}>{successMessage}</Alert>
                    </Snackbar>
                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={openError} onClose={handleClose} autoHideDuration={3000}>
                        <Alert onClose={handleClose} severity="error" dx={{ width: '300px' }}>{errorMessage}</Alert>
                    </Snackbar>
                </div>
            }
        </div>
    );
}
